// Reference: https://www.npmjs.com/package/crypto-js
// Reference: https://code.google.com/archive/p/crypto-js/

import CryptoJS from "crypto-js";
import { appConfig } from "../config/runtimeConfig";

const secretKey = appConfig.cryptoKey;
const ivKey = appConfig.cryptoIv;

export const encryptString = input => {
    const key = CryptoJS.enc.Base64.parse(secretKey);
    const randomIv = CryptoJS.lib.WordArray.random(16);
    const phraseEncrypt = CryptoJS.AES.encrypt(input, key, {iv: randomIv}).toString();
    return phraseEncrypt;
}

export const decryptString = input => {
    const key = CryptoJS.enc.Base64.parse(secretKey);
    const iv = CryptoJS.enc.Base64.parse(ivKey);
    const bytes = CryptoJS.AES.decrypt(input, key, {iv: iv});
    const originalText = bytes.toString(CryptoJS.enc.Utf8);
    return originalText;
}
